export default {
  PENDING: 100,
  ACCEPTED: 200,
  REJECTED: 300,
  statuses: [
    {
      id: 100,
      color: 'warning',
      name: {
        uz: 'Kutilmoqda',
        ru: 'В ожидании',
        en: 'Pending',
      },
    },
    {
      id: 200,
      color: 'success',
      name: {
        uz: 'Qabul qilingan',
        ru: 'Принятый',
        en: 'Accepted',
      },
    },
    {
      id: 300,
      color: 'danger',
      name: {
        uz: 'Rad etilgan',
        ru: 'Отклоненный',
        en: 'Rejected',
      },
    },
  ],
  monitoringReport: null,
  files: [],
}
